import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
  },
  contentWrapper: {
    width: 'calc(100% - 280px)',
  },
  content: {
    height: 'calc(100vh - 128px)',
    overflow: 'auto',
  },
  contentBody: {
    padding: theme.spacing(4, 5),
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    padding: theme.spacing(2, 5),
    backgroundColor: theme.palette.text.white,
    boxShadow: `0px -1px 0px 0px ${theme.palette.labraV2BoxShadow.dark} inset`,
    position: 'sticky',
    zIndex: 105,
    top: 0,
  },
  appTitleHeading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 'fit-content',
  },
  appBackIcon: {
    display: 'flex',
    margin: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  appTitleHeadingText: {
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '32px',
    color: theme.palette.labraText.primary,
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: 'calc(100vh - 64px)',
    overflow: 'hidden',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
  boldText: {
    fontWeight: 500,
    color: theme.palette.labraText.tertiary,
  },
  contentWrapperFullWidth: {
    width: '100%',
  },
}))
